import React, { useEffect, useState } from 'react';
import { Modal } from './modal';
import { Table } from 'antd';
import { faTable } from '@fortawesome/free-solid-svg-icons';
import { DataType, camelToTitleCase } from '@quyva/common';
// Expected data
// tableColumns = [column1,column2,column3]
// tableData =  [
//                  [data1,data2,data3],
//                  [data4,data5,data6],
//                  [data7,data8,data9]
//              ]

const pageSize = 10;

export const TableModal = ({
    title,
    titleIcon,
    iconColor,
    onClose,
    tableColumns,
    tableData,
    extraContent,
    pagination,
    modalClassName,
    isSmallScreen,
}) => {
    const [columnData, setColumnData] = useState([]);
    const [data, setData] = useState([]);

    useEffect(() => {
        const columns = tableColumns.map((column, index) => {
            return {
                title: camelToTitleCase(column),
                dataIndex: column,
                key: column,
                sorter: (a, b) => {
                    if (
                        typeof a[column] &&
                        typeof b[column] === DataType.NUMBER
                    ) {
                        return a[column] - b[column];
                    }
                    return a[column]
                        .toString()
                        .localeCompare(b[column].toString());
                },
            };
        });
        setColumnData(columns);

        const dataSource = tableData.map((rowData, index) => {
            const dataObject = { key: index };
            tableColumns.forEach((column, columnIndex) => {
                const raw = Array.isArray(rowData)
                    ? rowData[columnIndex]
                    : rowData[column];
                dataObject[column] =
                    raw !== null && raw !== undefined && typeof raw === 'object'
                        ? JSON.stringify(raw)
                        : raw;
            });
            return dataObject;
        });
        setData(dataSource);

        return () => {};
    }, [tableData, tableColumns]);

    return (
        <Modal
            title={title ? title : 'Table Data'}
            titleIcon={titleIcon ? titleIcon : faTable}
            iconColor={iconColor ? iconColor : 'sky'}
            onClose={onClose}
            className={modalClassName ? modalClassName : ''}
        >
            <div className='w-fit'>
                {extraContent && (
                    <div className={`p-2 ${isSmallScreen ? 'text-sm' : ''}`}>
                        {extraContent}
                    </div>
                )}
                <Table
                    dataSource={data}
                    columns={columnData}
                    bordered={true}
                    pagination={
                        pagination
                            ? pagination
                            : data.length <= pageSize
                            ? false
                            : { pageSize: pageSize }
                    }
                    size='small'
                />
            </div>
        </Modal>
    );
};
